import { RefObject, useEffect, useState } from 'react';

type Position = 'aboveViewport' | 'belowViewport' | 'inView' | null;

const useIntersectionObserver = (
  targetRef: RefObject<HTMLElement>,
  options: { root?: Element | Document | null; threshold: number; rootMargin?: string; initialPosition?: Position } = {
    root: null,
    threshold: 0.5,
    rootMargin: '0px',
    initialPosition: undefined,
  },
) => {
  const [position, setPosition] = useState<Position | null>(options?.initialPosition ?? null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setPosition('inView');
      } else {
        const bounding = entry.boundingClientRect;
        const viewportHeight = window.innerHeight;

        if (bounding.top < 0) {
          setPosition('aboveViewport');
        } else if (bounding.top > viewportHeight) {
          setPosition('belowViewport');
        } else {
          setPosition(null);
        }
      }
    }, options);

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => observer.disconnect();
  }, [targetRef, options]);

  return position;
};

export default useIntersectionObserver;
